export enum ProductCategory {
  None = -1,
  Tiltrotator = 0,
  MachineFixings = 1,
  Tools = 2,
}
